/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { useFormik, useFormikContext } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'
import { useAuth } from '../../../../app/modules/auth/core/Auth'
import { forgetPassword, getUserByToken, register } from '../../../../app/modules/auth/core/_requests'
import { Modal } from 'react-bootstrap'
import { clear } from 'console'
import Swal from 'sweetalert2'
import { AxiosError } from 'axios'

const initialValues = {
    email: ''
}

const forgetPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required')
})

type Props = {
    display: boolean,
    setDisplay: Function
}

const ForgetPasswordModal = ({ display, setDisplay }: Props) => {
    const [loading, setLoading] = useState(false)
    const { saveAuth, setCurrentUser } = useAuth()
    
    const formik = useFormik({
        initialValues,
        validationSchema: forgetPasswordSchema,
        onSubmit: async (values, { setStatus, setSubmitting, resetForm }) => {
            setLoading(true)
            try {
                const { data: auth } = await forgetPassword(
                    values.email
                )

                setLoading(false)
                let res = JSON.stringify(auth)
                console.log("reg response: "+res)

                Swal.fire({
                    title: 'Success!',
                    text: 'กรุณาตรวจสอบอีเมลเพื่อตั้งค่ารหัสผ่านใหม่',
                    icon: 'success'
                }).then(()=>{
                    resetForm();
                    setDisplay(false)
                })
                
            } catch (e) {
                console.error('error: '+e)
                const err = e as AxiosError
                const error_data = err.response?.data
                const error_msg = error_data.msg ?? 'ไม่พบอีเมลในระบบ'

                Swal.fire({
                    title: 'เกิดข้อผิดพลาด!',
                    text: error_msg,
                    icon: 'warning'
                })

                saveAuth(undefined)
                setStatus(error_msg)
                setSubmitting(false)
                setLoading(false)
            }
        },
    })

    useEffect(() => {
        PasswordMeterComponent.bootstrap()
    }, [])

    const clear = () => {
        
    }

    return (
        <Modal
            id="register_modal"
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px'
            show={display}
            onEntered={clear}
            >
            <div className="modal-header">
                <h5 className="modal-title">ตั้งค่ารหัสผ่านใหม่</h5>
                <div
                    className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                        setDisplay(false)
                    }}
                >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr061.svg"
                        className="svg-icon svg-icon-2x"
                    />
                </div>
            </div>
            <div className="modal-body">
                <form
                    className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                    noValidate
                    id='kt_login_signup_form'
                    onSubmit={formik.handleSubmit}
                >
                    <div className='mb-10 text-center'>
                        <h1 className='text-dark mb-3'>ลืมรหัสผ่าน</h1>
                        <h3 className='text-gray-800'>ระบบจะส่งลิงค์เพื่อตั้งค่าการใช้งานใหม่ กรุณาระบุอีเมลของคุณ</h3>
                    </div>

                    {formik.status && (
                        <div className='mb-lg-15 alert alert-danger'>
                            <div className='alert-text font-weight-bold'>{formik.status}</div>
                        </div>
                    )}

                    {/* begin::Form group Email */}
                    <div className='fv-row mb-7'>
                        <label className='form-label fw-bolder text-dark fs-6'>อีเมล</label>
                        <input
                            placeholder='Email'
                            type='email'
                            autoComplete='off'
                            {...formik.getFieldProps('email')}
                            className={clsx(
                                'form-control form-control-lg form-control-solid',
                                { 'is-invalid': formik.touched.email && formik.errors.email },
                                {
                                    'is-valid': formik.touched.email && !formik.errors.email,
                                }
                            )}
                        />
                        {formik.touched.email && formik.errors.email && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.email}</span>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* end::Form group */}

                    
                    {/* begin::Form group */}
                    <div className='text-center'>
                        <button
                            type='submit'
                            id='kt_sign_up_submit'
                            className='btn btn-lg btn-primary w-100 mb-5'
                            disabled={formik.isSubmitting || !formik.isValid}
                        >
                            {!loading && <span className='indicator-label'>ส่งอีเมล</span>}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                        <Link to='/auth/login'>
                            <button
                                type='button'
                                id='kt_login_signup_form_cancel_button'
                                className='btn btn-lg btn-light w-100 mb-5'
                                onClick={() => {
                                    setDisplay(false)
                                }}
                            >
                                ยกเลิก
                            </button>
                        </Link>
                    </div>
                    {/* end::Form group */}
                </form>
            </div>
            <div className="modal-footer">
                
            </div>
        </Modal>

    )
}

export { ForgetPasswordModal }